import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";
import { getMyCompanies } from "@/services/subscriptionService";

export interface UseMyCompaniesOptions {
  /** When false, skips fetching (e.g. profile modal closed). */
  enabled?: boolean;
}

/**
 * Fetches companies where the current user is an HR admin.
 * Used to detect company context (e.g. redirect to company portal, hide upgrade/referral UI).
 * Passes session.access_token to avoid timing issues with getAuthToken().
 */
export function useMyCompanies(options?: UseMyCompaniesOptions) {
  const { user, session } = useAuth();

  return useQuery({
    queryKey: ["myCompanies", user?.id, session?.access_token ? "token" : "no-token"],
    queryFn: () => getMyCompanies(session?.access_token ?? undefined),
    enabled: !!(user?.id && session?.access_token) && (options?.enabled ?? true),
    staleTime: 60 * 1000,
  });
}
